<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card class="px-4 pb-4">
      <v-card-title class="mx-3">
        {{ $t("shopDailyReports.Fields.errHint") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="Headers"
        :items="errData"
        multi-sort
        disable-pagination
        hide-default-footer
        class="pb-2"
      >
        <template v-slot:item.msg="{ item }">
          <span class="red--text">
            {{ item.msg }}
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";

export default {
  props: {
    value: Boolean,
    errData: Array,
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    Headers() {
      return [
        {
          text: i18n.t("shopDailyReports.Fields.shop_code"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_code",
        },
        {
          text: i18n.t("shopDailyReports.Fields.shop_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_name",
        },
        {
          text: i18n.t("shopDailyReports.Fields.food_code"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "food_code",
        },
        {
          text: i18n.t("shopDailyReports.Fields.food_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "food_name",
        },
        {
          text: i18n.t("shopDailyReports.Fields.food_behavior_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "food_behavior_name",
        },
        {
          text: i18n.t("shopDailyReports.Fields.material_code"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "material_code",
        },
        {
          text: i18n.t("shopDailyReports.Fields.material_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: i18n.t("shopDailyReports.Fields.msg"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "msg",
        },
      ];
    },
  },
  watch: {
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
        }
      },
    },
  },
};
</script>
